module.exports = __webpack_public_path__ + "static/about3-8e3781c6c72038e0d9dd11eeb916c191.png";